<div >
  @if (isAuthenticated$ | async) {
    <ul class="navbar-nav">
      <li class="nav-item dropdown">
        <a class="nav-link avatar-toggle d-flex align-items-center" href="#" role="button"
          data-bs-toggle="dropdown" aria-expanded="false" title="{{ profile?.user.fullName }}"
          data-testid="account-menu-toggle">
          <fa-icon [icon]="faUserCircle" class="fs-4"></fa-icon>
          <span class="avatar-name">{{ profile?.user.firstName }}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-end">
          <li>
            <h6 class="dropdown-header">{{ profile?.user.fullName }}</h6>
          </li>
          <li><hr class="dropdown-divider" /></li>
          <app-my-account-nav variant="dropdown"></app-my-account-nav>
          <li><hr class="dropdown-divider" /></li>
          <li>
            <a class="dropdown-item" [routerLink]='["/authentication/logout"]' [state]='{ local: true }'
              [queryParams]="{returnUrl: '/'}" data-testid="logout-link" i18n>Abmelden</a>
          </li>
        </ul>
      </li>
    </ul>
  }
  @if (!(isAuthenticated$ | async)) {
    <ul class="navbar-nav px-3">
      <li class="nav-item text-nowrap">
        <a class="nav-link" [routerLink]='["/authentication/register"]' data-testid="register-link" i18n>Registrieren</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]='["/authentication/login"]' [queryParams]="{returnUrl: ApplicationPaths.Shop}" data-testid="login-link" i18n>Anmelden</a>
      </li>
    </ul>
  }

</div>